import * as types from './action-types';
import { errorHandler } from '../../../utils/errors';
import CorporateQuoteApi from '../../../api/CorporateQuoteApi';


// FETCH quote Summary
export const fetchQuoteSummary = (quoteId, countryCode, companyCode) => ({
    type: types.FETCH_QUOTE_SUMMARY,
    payload: CorporateQuoteApi.getSummary(quoteId, countryCode, companyCode)
});

// FETCH quotes
export const fetchQuotesApproval = (payload) => ({
    type: types.FETCH_QUOTES,
    payload: CorporateQuoteApi.getQuotesApproval(payload)
});

export const sendEmail = payload => {
  return dispatch => {
    return CorporateQuoteApi.sendEmail(payload);
  };
};

export const setFilter = filter => ({
  type: types.SET_FILTER,
  data: filter
});

//export quote
export const exportQuote = (quoteId) => ({
  type: types.EXPORT_QUOTE,
  payload: CorporateQuoteApi.exportQuote(quoteId)
});



// WEBPACK FOOTER //
// ./src/features/corporate-quote/workflow/actions.js